module.exports = __webpack_public_path__ + "static/img/yiti_04.7af3f389.jpg";